import DesktopPrimaryNav from './DesktopPrimaryNav';

export { type DesktopPrimaryNavProps } from './DesktopPrimaryNav';
export default DesktopPrimaryNav;
